<div class="table-container">
  <table mat-table matSort [dataSource]="datapointsDataSource">

    <ng-container matColumnDef="deviceId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceId">{{'bacnet-datapoint.header.deviceId' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.deviceId}}</td>
    </ng-container>

    <ng-container matColumnDef="key">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="key">{{'mbus-datapoint-configurator.header.key' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.key}}</td>
    </ng-container>

    <ng-container matColumnDef="dataType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dataType">{{'bacnet-datapoint.header.dataPointName' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.dataType}}</td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="value">{{'bacnet-datapoint-configurator.header.value' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.value}}</td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="unit">{{'bacnet-datapoint-configurator.header.unit' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.unit}}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description">{{'mbus-datapoint-configurator.header.description' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.description}}</td>
    </ng-container>

    <ng-container matColumnDef="pollingIntervalSeconds">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="pollingIntervalSeconds">{{'bacnet-config-table.header.polling-frequency' | translate}}</th>
      <td mat-cell *matCellDef="let dataPoint">{{dataPoint.pollingIntervalSeconds}}</td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
